<template>
  <div class="applyForEmbody">
    <van-sticky>
      <div
        class="applyForEmbodyNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">申请提现</span>
      </div>
    </van-sticky>
    <div class="content">
      <div class="card">
        <div class="top">
          <h3>提现金额</h3>
        </div>
        <div class="money">
          <span>￥</span>
          <van-field
            v-model="money"
            type="number"
            placeholder="0.00"
            @blur="numFormatting()"
            @input="inputChange()"
          />
        </div>
        <div class="item">
          <p>可提现总金额:{{ balance }}</p>
          <div @click="allEmbody()">
            <img
              v-if="isAllEmbody"
              src="./../../../assets/decoration/checkedY.png"
              alt=""
            />
            <img
              v-else
              src="./../../../assets/decoration/uncheckedY.png"
              alt=""
            />
            <p>全部提现</p>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="top">
          <h3>上传发票<span>*</span></h3>
          <p>{{ fileList.length }}/9</p>
        </div>
        <div class="uploadBtm">
          <van-uploader
            v-model="fileList"
            :max-count="9"
            :accept="accept"
            multiple
            :after-read="afterRead"
            :before-read="beforeRead"
          >
            <div class="box">
              <img src="./../../../assets/decoration/addImg.png" />
            </div>
          </van-uploader>
        </div>
      </div>
      <div class="tip">
        <p>提现说明：</p>
        <p>
          1.提现需要提供发票凭证，查看<span @click="toInvoice()"
            >发票信息;</span
          >
        </p>
        <p>
          2.为了您提现的顺利进行，请确保①发票金额与提现到账金额一致；②请提供清晰的电子发票凭证，暂不支持纸质发票。
        </p>
        <p>3.提现金额默认提到个人余额账户。</p>
      </div>
    </div>
    <div class="btm">
      <div class="btn" @click="embody()">提现</div>
    </div>
    <div class="loading" v-if="loading">
      <img src="./../../../assets/decoration/laoding.gif" />
    </div>
  </div>
</template>
<script>
import Upload from "./../../../providers/upload";
export default {
  data() {
    return {
      isiOSX: false,
      type: 1, //1代理人，2合伙人
      city_agent_id: null,
      data: {},
      money: null, //提现金额
      isAllEmbody: false,
      balance: null, //余额
      fileList: [], //发票凭证
      accept: "image/jpeg, image/jpg, image/png", //允许上传的图片类型
      needRefresh: true,
      loading: false,
      csrf_token: null,
      operator_origin: null, //操作源 10-APP安卓；11-APPIOS;
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.deductionUA();
  },
  activated() {
    if (this.needRefresh) {
      this.money = null;
      this.fileList = [];
      this.isAllEmbody = false;
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
      }
      if (this.$route.query.city_agent_id) {
        this.city_agent_id = this.$route.query.city_agent_id;
      }
      this.getData();
      this.getCsrfToken();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/decoration/embody/invoice") {
      this.needRefresh = false;
    } else {
      this.needRefresh = true;
    }
    next();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 判断手机机型
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.operator_origin = 11;
      } else if (/android/.test(ua)) {
        this.operator_origin = 10;
      }
    },
    //格式化输入金额为小数点后两位
    numFormatting() {
      if (this.money) {
        this.money = (Number(this.money * 100) / 100).toFixed(2);
      }
    },
    // 改变数值，取消全选
    inputChange() {
      this.isAllEmbody = false;
    },
    // 获取防重复token
    getCsrfToken() {
      this.$api
        .get("decoration/basic/csrf/token")
        .then((res) => {
          this.csrf_token = res.csrf_token;
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    getData() {
      if (this.type == 1) {
        // 代理人
        this.$api
          .get("decoration/member/withdrawal/city/agent/is/withdrawal", {
            city_agent_id: this.city_agent_id,
          })
          .then((res) => {
            this.balance = res.balance;
            this.data = res;
          });
      } else {
        // 合伙人
        this.$api
          .get("decoration/member/withdrawal/city/partner/is/withdrawal", {
            city_partner_area_id: this.city_agent_id,
          })
          .then((res) => {
            this.balance = res.balance;
            this.data = res;
          });
      }
    },
    allEmbody() {
      this.isAllEmbody = !this.isAllEmbody;
      if (this.isAllEmbody) {
        this.money = this.balance;
      } else {
        this.money = null;
      }
    },
    beforeRead(file) {
      if (file.size == 0 || JSON.stringify(file.file) == "{}") {
        //解决部分机型取消上传还是添加空白图片
        return false;
      } else {
        return true;
      }
    },
    afterRead(file) {
      if (Array.isArray(file)) {
        // 多选
        file.forEach((item) => {
          this.imgUpload(item);
        });
      } else {
        // 单选
        this.imgUpload(file);
      }
    },
    // 图片上传
    imgUpload(file) {
      file.status = "uploading";
      file.message = "上传中...";
      Upload.upload(file.file, ["others"])
        .then((res) => {
          file.status = "";
          file.message = "";
          file.src = res;
        })
        .catch((res) => {
          file.status = "failed";
          file.message = "失败";
        });
    },
    embody() {
      let voucher = [];
      this.fileList.forEach((item) => {
        if (item.src) {
          voucher.push(item.src);
        } else {
          this.$toast("图片正在上传中，请稍等");
          return;
        }
      });
      if (this.data.status == -3) {
        this.$toast("需先解除拉黑才可进行提现操作。");
      } else if (this.money < 1) {
        this.$toast("提现金额不可小于1元，请输入正确的提现金额。");
      } else if (this.money > Number(this.data.balance)) {
        this.$toast("提现金额大于可提现金额，请输入正确的提现金额。");
      } else {
        this.loading = true;
        let apiUrl = "";
        let params = {};
        if (this.type == 1) {
          apiUrl = "decoration/member/withdrawal/city/agent/store";
          params = {
            voucher: voucher,
            money: this.money,
            city_agent_id: Number(this.city_agent_id),
            csrf_token: this.csrf_token,
            operator_origin: this.operator_origin,
          };
        } else {
          apiUrl = "decoration/member/withdrawal/city/partner/store";
          params = {
            voucher: voucher,
            money: this.money,
            city_partner_area_id: Number(this.city_agent_id),
            csrf_token: this.csrf_token,
            operator_origin: this.operator_origin,
          };
        }
        this.$api
          .post(apiUrl, params)
          .then((res) => {
            this.loading = false;
            this.$router.push({
              path: "/decoration/embody/embodySuccess",
              query: {
                money: this.money,
                id: res.id,
                type: this.type,
              },
            });
          })
          .catch((err) => {
            this.$toast(err.message);
            this.loading = false;
          });
      }
    },
    toInvoice() {
      this.$router.push({
        path: "/decoration/embody/invoice",
        query: {
          is_company: this.data.is_company,
        },
      });
    },
  },
};
</script>
<style lang="less">
.applyForEmbody {
  min-height: 100%;
  background: #f5f6ff;
  .applyForEmbodyNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 0 16px;
    padding-bottom: 83px;
    .card {
      margin-top: 12px;
      background: #ffffff;
      border-radius: 13px;
      padding: 20px 0px;
      .top {
        display: flex;
        justify-content: space-between;
        align-content: center;
        margin: 0 16px 6px;
        h3 {
          font-size: 14px;
          font-weight: 700;
          color: #333333;
          line-height: 20px;
          margin: 0;
          span {
            color: #e43737;
            margin-left: 8px;
          }
        }
        p {
          font-size: 12px;
          color: #999999;
          line-height: 17px;
        }
      }
      .money {
        border-bottom: 1px solid #f0f1ff;
        display: flex;
        align-items: center;
        margin: 16px 16px 0px;
        span,
        input {
          font-size: 32px;
          font-weight: 700;
          color: #333333;
          line-height: 45px;
        }
        .van-cell {
          padding-left: 8px;
        }
      }
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 16px 16px 0px;

        p {
          font-size: 14px;
          color: #333333;
          line-height: 20px;
        }
        div {
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
        }
      }
      .uploadBtm {
        display: flex;
        margin: 0px 8px 0px 16px;
        img,
        .van-uploader__preview-image {
          width: 100%;
          height: 100%;
        }
        .van-uploader__preview,
        .box {
          margin: 8px 8px 0 0;
          width: 71px;
          height: 71px;
        }
      }
    }
    .tip {
      margin: 15px 8px;
      p {
        font-size: 13px;
        color: #999999;
        line-height: 20px;
        span {
          color: #5853e9;
          text-decoration: underline;
        }
      }
    }
  }
  // 底部按钮
  .btm {
    width: 100%;
    height: 83px;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    .btn {
      flex: 1;
      margin: 2px 17px 0;
      background-color: #5853e9;
      border-radius: 25px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      color: #ffffff;
      font-size: 16px;
    }
  }
  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
    p {
      color: #e7e9fd;
      margin-top: -30px;
      font-size: 13px;
    }
  }
}
</style>